import { IPhoneSubSchema } from '../../../graphql/type/subSchema/phone';

const tel = {
  getLink: (tempTel: IPhoneSubSchema): string =>
    `tel:+${tempTel.countryCode}${tempTel.number}`,
};
export default tel;
